import { MediaImage } from "components/ui/v2/media-image";
import SvgV2 from "components/ui/v2/svg-v2";
import type { ComponentType } from "react";

interface ISvgProps {
  readonly src:
    | string
    | { readonly src: string }
    | ComponentType<{ className?: string; width?: number; height?: number }>;
  readonly width?: number;
  readonly height?: number;
  readonly onClick?: () => void;
  readonly className?: string;
  readonly alt?: string;
  readonly moduleOpacity?: boolean;
}

/**
 * @deprecated Prefer:
 * - `ModuleIcon` for sidebar/module icons
 * - `MediaImage` for illustrations / empty states
 * - `lucide-react` for UI icons
 *
 * Kept as a thin bridge: module paths → Lucide via svg-v2; other assets → MediaImage.
 */
export default function SVG(props: ISvgProps) {
  const src =
    typeof props.src === "string"
      ? props.src
      : props.src && typeof props.src === "object" && "src" in props.src
        ? props.src.src
        : "";

  if (typeof src === "string" && src.startsWith("/icon/modules/")) {
    return <SvgV2 {...props} />;
  }

  return (
    <MediaImage
      src={props.src}
      width={props.width}
      height={props.height}
      onClick={props.onClick}
      className={props.className}
      alt={props.alt}
    />
  );
}
